/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.28",
    versionName: "0.2.0-nightly.2026.1.28",
    versionChannel: "nightly",
    buildDate: "2026-01-28T00:08:08.863Z",
    commitHash: "e4d871a7deb18bee6bdfe1b34e765e9c0ec1cbe0",
};
